import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import * as React from "react";
import {FermentationTimingSettingsControl} from "./FermentationTimingSettingsControl(props)";

function FermentationTimingSettingsDialog(props) {
  const {open, close, pctName, pctLabel, pctValue, pctValueArr, tempName, tempLabel, tempValue, tempValueArr, change, stateLabel} = props

  return (
    <div>
      <Dialog fullWidth={true} maxWidth={'md'} open={open} onClose={close}>
        <DialogTitle>Fermentation Timing Settings</DialogTitle>
        <DialogContent>
          <FermentationTimingSettingsControl pctName={pctName} pctLabel={pctLabel} pctValue={pctValue} pctValueArr={pctValueArr}
                                             tempName={tempName} tempLabel={tempLabel} tempValue={tempValue} tempValueArr={tempValueArr}
                                             change={change} stateLabel={stateLabel} />
        </DialogContent>
        <DialogActions>
          <Button variant={"outlined"} onClick={close}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export {FermentationTimingSettingsDialog}